import { Alert, Box, CircularProgress, Typography } from '@mui/material';
import type { ReactNode } from 'react';

interface DataStateProps<T> {
  loading: boolean;
  error: unknown;
  data: T | undefined;
  isEmpty?: (data: T) => boolean;
  emptyMessage?: string;
  children: (data: T) => ReactNode;
}

export function DataState<T>({ loading, error, data, isEmpty, emptyMessage = 'No data yet.', children }: DataStateProps<T>) {
  if (loading) {
    return (
      <Box sx={{ py: 6, display: 'grid', placeItems: 'center' }}>
        <CircularProgress />
      </Box>
    );
  }
  if (error) {
    const message = error instanceof Error ? error.message : 'Failed to load.';
    return <Alert severity="error">{message}</Alert>;
  }
  if (data === undefined) {
    return null;
  }
  if (isEmpty && isEmpty(data)) {
    return (
      <Box sx={{ py: 6, textAlign: 'center' }}>
        <Typography variant="body2" color="text.secondary">
          {emptyMessage}
        </Typography>
      </Box>
    );
  }
  return <>{children(data)}</>;
}
